/**
 * Acaderma desktop dropdown + mobile accordion controller.
 * Markup uses [data-menu-trigger] / [data-menu-panel] + .is-open
 * (see sections/header.liquid + assets/header_new.css).
 */
(function ($) {
  if (!$ || window.__acadermaHeaderNavBound) return;
  window.__acadermaHeaderNavBound = true;

  var hideTimer = null;

  function clearHideTimer() {
    if (hideTimer) {
      window.clearTimeout(hideTimer);
      hideTimer = null;
    }
  }

  function scheduleHide() {
    clearHideTimer();
    hideTimer = window.setTimeout(hideMenus, 140);
  }

  function syncCollectionHubDropdownAnchor() {
    var collTr = document.querySelector('.coll_tr');
    if (!collTr) return null;
    var collStyle = window.getComputedStyle(collTr);
    if (collStyle.display === 'none' || collStyle.visibility === 'hidden') return null;
    // Flush to the category strip bottom (no extra gap under Step 1 / Step 2…).
    var top = Math.ceil(collTr.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--acaderma-nav-dropdown-top', top + 'px');
    return top;
  }

  function positionMenu(key) {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    var menu = document.querySelector('.top_sub_menu');
    var header = document.querySelector('.top_sub');
    var trigger = document.querySelector('[data-menu-trigger="' + key + '"]');
    if (!menu || !header || !trigger) return;

    var label = trigger.querySelector('span, a') || trigger;
    var headerBottom = Math.ceil(header.getBoundingClientRect().bottom);
    var anchorBottom = headerBottom;

    var collTop = syncCollectionHubDropdownAnchor();
    if (collTop != null) {
      anchorBottom = Math.max(anchorBottom, collTop);
    }

    // Prefer open panel width so left clamp matches the visible card.
    var openPanel = menu.querySelector('.top_sub_menu_panel.is-open');
    var menuWidth = Math.ceil(
      (openPanel && (openPanel.getBoundingClientRect().width || openPanel.offsetWidth)) ||
        menu.getBoundingClientRect().width ||
        menu.offsetWidth ||
        0
    );
    var cardPadding = 28;
    var viewportInset = 24;
    var desiredLeft = Math.round(label.getBoundingClientRect().left - cardPadding);
    var clampedLeft = Math.min(
      Math.max(desiredLeft, viewportInset),
      Math.max(viewportInset, window.innerWidth - menuWidth - viewportInset)
    );

    menu.style.setProperty('left', clampedLeft + 'px');
    menu.style.setProperty('right', 'auto');
    // !important so stylesheet fallbacks (cached CSS) cannot leave a gap.
    menu.style.setProperty('top', anchorBottom + 'px', 'important');
  }

  function hideMenus() {
    clearHideTimer();
    var menu = document.querySelector('.top_sub_menu');
    if (menu) {
      menu.style.removeProperty('left');
      menu.style.removeProperty('top');
      menu.style.removeProperty('right');
    }
    $('.top_sub_menu')
      .removeClass('is-open top_sub_menu--shop top_sub_menu--about top_sub_menu--science top_sub_menu--quiz top_sub_menu--gift top_sub_menu--feature top_sub_menu--shop-compact')
      .css({ display: 'none', left: '', top: '', right: '' });
    $('[data-menu-panel]').removeClass('is-open').css('display', 'none');
    $('[data-menu-trigger]').removeClass('is-active');
    $('.top_sub_menu_scrim').removeClass('is-open');
    $('.top_sub').removeClass('top_sub--nav-open');
  }

  function showMenu(key) {
    var $panel = $('[data-menu-panel="' + key + '"]');
    if (!$panel.length) {
      hideMenus();
      return;
    }

    hideMenus();
    clearHideTimer();

    $('[data-menu-trigger="' + key + '"]').addClass('is-active');
    $('.top_sub').addClass('top_sub--nav-open');
    $('.top_sub_menu')
      .addClass('is-open top_sub_menu--' + key)
      .css('display', 'block');
    $panel.addClass('is-open').css('display', 'block');
    $('.top_sub_menu_scrim').addClass('is-open');
    // Measure after the open panel paints so width/left clamp are correct.
    window.requestAnimationFrame(function () {
      positionMenu(key);
    });
  }

  function setMobileAccordion($toggle, isOpen) {
    var panelId = $toggle.attr('aria-controls');
    var $panel = panelId ? $('#' + panelId) : $();
    $toggle.attr('aria-expanded', isOpen ? 'true' : 'false').toggleClass('is-open', isOpen);
    $panel.prop('hidden', !isOpen).toggleClass('is-open', isOpen);
  }

  function resetMobileAccordions() {
    $('[data-mobile-toggle]').each(function () {
      setMobileAccordion($(this), false);
    });
  }

  function setMobileMenuOpen(isOpen) {
    $('.top_sub_menu_mobile').css('display', isOpen ? 'block' : 'none');
    $('.prelative').toggleClass('mob_cha', isOpen);
    $('body').toggleClass('mobile-nav-open', isOpen);
    if (!isOpen) resetMobileAccordions();
  }

  $(function () {
    $('[data-menu-trigger]').on('mouseenter focusin', function () {
      clearHideTimer();
      var key = $(this).attr('data-menu-trigger');
      if (!key || key === 'home') {
        hideMenus();
        return;
      }
      // Skin Quiz is a direct link — no dropdown panel required.
      if (key === 'quiz' && !$('[data-menu-panel="quiz"]').length) return;
      showMenu(key);
    });

    $('.top_sub, .top_sub_menu').on('mouseenter', clearHideTimer);

    $('.top_sub').on('mouseleave', function (e) {
      if ($(e.relatedTarget).closest('.top_sub_menu').length) return;
      scheduleHide();
    });

    $('.top_sub_menu').on('mouseleave', function (e) {
      if ($(e.relatedTarget).closest('.top_sub').length) return;
      scheduleHide();
    });

    $('.top_sub_menu_scrim').on('click', hideMenus);

    $('[data-mobile-toggle]').on('click', function () {
      var $toggle = $(this);
      var willOpen = $toggle.attr('aria-expanded') !== 'true';
      $('[data-mobile-toggle]').not($toggle).each(function () {
        setMobileAccordion($(this), false);
      });
      setMobileAccordion($toggle, willOpen);
    });

    $('.prelative').on('click', function () {
      setMobileMenuOpen($('.top_sub_menu_mobile').css('display') === 'none');
    });

    $('.top_sub_menu_mobile a').on('click', function () {
      setMobileMenuOpen(false);
    });

    $(window).on('resize', function () {
      syncCollectionHubDropdownAnchor();
      var active = $('[data-menu-trigger].is-active').attr('data-menu-trigger');
      if (active && $('.top_sub_menu').hasClass('is-open')) positionMenu(active);
      if (window.matchMedia('(min-width: 990px)').matches && $('body').hasClass('mobile-nav-open')) {
        setMobileMenuOpen(false);
      }
    });

    syncCollectionHubDropdownAnchor();
    resetMobileAccordions();
    hideMenus();

    /* Story hero: keep desert car visible despite sticky page HTML + object-center crop. */
    try {
      var storyHero = document.querySelector('img[src*="story-hero-banner"]');
      if (storyHero) storyHero.style.setProperty('object-position', '70% 80%', 'important');
    } catch (e) {}
  });
})(window.jQuery);
